import React, { useState, useEffect } from 'react';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useAuth from '../../dashboard/useAuth';
import { FaChalkboardTeacher, FaCalendarAlt, FaPlus, FaTimes, FaExclamationTriangle } from 'react-icons/fa';
import axios from 'axios';
import { Modal, Button, Form, Alert } from 'react-bootstrap';

const AjouterFormation = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);

    const [formData, setFormData] = useState({
        nom: '',
        reference: '',
        prix: '',
        code: '',
        prix_particulier: '',
        periode: '',
        option: 'presentiel',
        lieu: '',
        nb_participants: '',
        periode_coaching: '',
    });

    const [photo, setPhoto] = useState(null);
    const [selectedDates, setSelectedDates] = useState([]);

    useEffect(() => {
        if (user_id) {
            document.title = 'eTrainApp | Ajouter Formation';
        }
    }, [user_id]);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setPhoto(file);
    };

    // Fonction pour vérifier si une date est dans le passé
    const isDateInPast = (dateString) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Remettre à minuit pour comparer seulement les dates
        const selectedDate = new Date(dateString);
        return selectedDate < today;
    };

    // Fonction pour obtenir la date minimum autorisée (date la plus récente + 1 jour)
    // const getMinDate = () => {
    //     if (selectedDates.length === 0) {
    //         const today = new Date();
    //         const day = String(today.getDate()).padStart(2, '0');
    //         const month = String(today.getMonth() + 1).padStart(2, '0');
    //         const year = today.getFullYear();
    //         return `${day}-${month}-${year}`; // Format: DD-MM-YYYY
    //     }

    //     // Trouver la date la plus récente
    //     const sortedDates = [...selectedDates].sort();
    //     const mostRecentDate = new Date(sortedDates[sortedDates.length - 1]);

    //     // Ajouter 1 jour
    //     const nextDay = new Date(mostRecentDate);
    //     nextDay.setDate(nextDay.getDate() + 1);

    //     // Formater en DD-MM-YYYY
    //     const day = String(nextDay.getDate()).padStart(2, '0');
    //     const month = String(nextDay.getMonth() + 1).padStart(2, '0');
    //     const year = nextDay.getFullYear();

    //     return `${day}-${month}-${year}`;
    // };

    // Fonction pour ajouter une date avec contrôle
    const handleAddDate = (date) => {
        const dateStr = date;

        // Vérifier si la date est dans le passé
        if (isDateInPast(dateStr)) {
            showAlert('Impossible de sélectionner une date déjà passée.', 'danger');
            return;
        }

        if (!selectedDates.includes(dateStr)) {
            // Ajouter la date sans vérifier l'ordre
            const newDates = [...selectedDates, dateStr];
            // Trier automatiquement les dates
            const sortedDates = newDates.sort();
            setSelectedDates(sortedDates);
        }
    };

    const handleRemoveDate = (dateToRemove) => {
        setSelectedDates(prev => prev.filter(date => date !== dateToRemove));
    };

    // Fonction pour formater l'affichage des dates
    const formatDateDisplay = (dateString) => {
        return new Date(dateString).toLocaleDateString('fr-FR', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    // Fonction pour réorganiser les dates après une suppression
    const reorganizeDatesAfterRemoval = (remainingDates) => {
        // Trier les dates restantes
        return [...remainingDates].sort();
    };

    // Modifier handleRemoveDate pour réorganiser après suppression
    const handleRemoveDateWithReorganization = (dateToRemove) => {
        const remainingDates = selectedDates.filter(date => date !== dateToRemove);
        // Trier les dates restantes
        const sortedDates = remainingDates.sort();
        setSelectedDates(sortedDates);
    };

    const validateForm = () => {
        const { nom, option, prix, lieu } = formData;
        return nom && prix && option && lieu && photo;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!validateForm()) {
            showAlert('Tous les champs obligatoires doivent être remplis.', 'danger');
            return;
        }

        setIsLoading(true);

        const data = new FormData();
        data.append('nom', formData.nom);
        data.append('reference', formData.reference);
        data.append('prix', formData.prix);
        data.append('code', formData.code);
        data.append('prix_particulier', formData.prix_particulier);
        data.append('option', formData.option);
        data.append('lieu', formData.lieu);
        data.append('nb_participants', formData.nb_participants);
        data.append('periode_coaching', formData.periode_coaching);
        data.append('photo', photo);

        // Ajouter les dates au format JSON (triées)
        const sortedDates = [...selectedDates].sort();
        data.append('dates_formation', JSON.stringify(sortedDates));

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-formation/${user_id}/`, {
                method: 'POST',
                body: data,
            });

            if (!response.ok) {
                const errorData = await response.json();
                showAlert(`Erreur lors de la création de la formation: ${errorData.error || 'Erreur serveur'}`, 'danger');
            } else {
                const responseData = await response.json();
                showAlert('Formation créée avec succès !', 'success');
                navigate('/Liste-formation');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur réseau. Veuillez réessayer.', 'danger');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        setFormData({
            nom: '',
            reference: '',
            prix: '',
            code: '',
            prix_particulier: '',
            periode: '',
            option: '',
            lieu: '',
            nb_participants: '',
            periode_coaching: '',
        });
        setPhoto(null);
        setSelectedDates([]);
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Formation")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaChalkboardTeacher size={25} className='mr-2' />Nouvelle formation</h2>
                            <small>Administration des formations.</small>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-formation`}>Formation</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Nouvelle Formation
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8 mx-auto mt-3 mb-3">
                        <div className="ibox-content">
                            <div className="hpanel">
                                <div className="panel-body">
                                    {alert.message && (
                                        <div className={`alert alert-${alert.type}`}>{alert.message}</div>
                                    )}
                                    <form className="m-t row" encType="multipart/form-data">
                                        <div className="form-group col-md-6">
                                            <label>Nom <span className='text-danger'>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Nom de la formation"
                                                required
                                                name="nom"
                                                value={formData.nom}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Référence <span className='text-danger'>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Référence de la formation"
                                                required
                                                name="reference"
                                                value={formData.reference}
                                                onChange={handleInputChange}
                                            />
                                            <small>Si vous ne renseignez rien, cette référence sera auto-générée.</small>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Tarif public <span className='text-danger'>*</span></label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Tarif public"
                                                required
                                                name="prix"
                                                value={formData.prix}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Tarif particulier <span className='text-danger'>*</span></label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Tarif particulier"
                                                required
                                                name="prix_particulier"
                                                value={formData.prix_particulier}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Code formation <span className='text-danger'>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Code formation"
                                                required
                                                name="code"
                                                value={formData.code}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Lieu <span className='text-danger'>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Lieu"
                                                required
                                                name="lieu"
                                                value={formData.lieu}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Nombre de participants <span className='text-danger'>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Nombre de participants"
                                                required
                                                name="nb_participants"
                                                value={formData.nb_participants}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Option <span className='text-danger'>*</span></label>
                                            {/* <input
                                                className="form-control"
                                                name="option"
                                                placeholder="Option"
                                                required
                                                value={formData.option}
                                                onChange={handleInputChange}
                                            /> */}
                                            <Form.Select
                                                className='custom-select'
                                                value={formData.option}
                                                onChange={(e) => setFormData({ ...formData, option: e.target.value })}
                                                required
                                            >
                                                <option value="">Selectionnez une option</option>
                                                <option value="en_ligne">Virtuel</option>
                                                <option value="presentiel">Présentiel</option>
                                                <option value="deux">Les deux</option>
                                            </Form.Select>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Photo <span className='text-danger'>*</span></label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                required
                                                name="photo"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label>Période de coaching <span className='text-danger'>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Période de coaching"
                                                required
                                                name="periode_coaching"
                                                value={formData.periode_coaching}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        {/* Gestionnaire de dates multiples avec contrôles */}
                                        <div className="form-group col-md-12">
                                            <label>Dates de la formation</label>

                                            <div className="card mb-3">
                                                <div className="card-body p-3">
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <div>
                                                            <strong>Dates sélectionnées</strong>
                                                            <span className="badge badge-secondary ml-2">
                                                                {selectedDates.length} date{selectedDates.length !== 1 ? 's' : ''}
                                                            </span>
                                                        </div>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <Form.Control
                                                                type="date"
                                                                size="sm"
                                                                style={{ width: '200px' }}
                                                                onChange={(e) => {
                                                                    if (e.target.value) {
                                                                        handleAddDate(e.target.value);
                                                                        e.target.value = '';
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Instructions */}
                                                    {/* <Alert variant="info" className="p-2 small mb-3">
                                                        <FaExclamationTriangle className="mr-2" />
                                                        <strong>Instructions :</strong> Les dates seront automatiquement triées dans l'ordre chronologique.
                                                    </Alert> */}

                                                    {selectedDates.length > 0 ? (
                                                        <div className="selected-dates-list">
                                                            <div className="d-flex flex-column gap-2">
                                                                {[...selectedDates].sort().map((date, index) => (
                                                                    <div key={index} className="d-flex align-items-center justify-content-between p-2 border rounded bg-light">
                                                                        <div className="d-flex align-items-center">
                                                                            <FaCalendarAlt className="mr-2 text-primary" />
                                                                            <div>
                                                                                <strong>{formatDateDisplay(date)}</strong>
                                                                                {index === 0 && <span className="badge badge-success ml-2">Début</span>}
                                                                                {index === selectedDates.length - 1 && <span className="badge badge-info ml-2">Fin</span>}
                                                                            </div>
                                                                        </div>
                                                                        <Button
                                                                            variant="outline-danger"
                                                                            size="sm"
                                                                            onClick={() => handleRemoveDateWithReorganization(date)}
                                                                            className="d-flex align-items-center"
                                                                            title="Supprimer cette date"
                                                                        >
                                                                            <FaTimes />
                                                                        </Button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <Alert variant="warning" className="mb-0 d-flex align-items-center">
                                                            <FaCalendarAlt className="mr-2" />
                                                            Aucune date sélectionnée. Sélectionnez la première date de votre formation.
                                                        </Alert>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                    <div className="text-center mt-5">
                                        <Link to="/Liste-formation" className="btn btn-default mr-2">
                                            Annuler
                                        </Link>
                                        <button type="button" className="btn btn-default mr-2" onClick={handleCancel}>
                                            Effacer
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-success"
                                            onClick={handleSubmit}
                                            disabled={isLoading}
                                        >
                                            {isLoading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                    Enregistrement...
                                                </>
                                            ) : (
                                                'Enregistrer'
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AjouterFormation;